/**
 * Stylized illustration of the U.S. Virgin Islands (St. Thomas, St. John,
 * St. Croix). Static image — not interactive.
 */
export function UsviMap({ className }: { className?: string }) {
  return (
    <img
      src="/images/usvi-map.png"
      alt="Illustrated map of the U.S. Virgin Islands — St. Thomas, St. John, and St. Croix"
      loading="lazy"
      className={className}
    />
  )
}
